import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const anaplan: GetCustomerCopyFunc = () => {
  return {
    displaySessionLimit: false, // This is a deliberate choice on behalf of Anaplan even though they have session limits
  }
}
